export const convertToRGBA = (color: string, opacity: number): string => {
  let r: number | undefined,
    g: number | undefined,
    b: number | undefined,
    a = 1;

  // Trim to remove any leading/trailing whitespace
  color = color.trim();

  // Handle Hex Color
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }
  }
  // Handle RGB(A) Strings
  else if (color.startsWith("rgb")) {
    const match = color.match(/(\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?/);
    if (match) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
      if (match[4] !== undefined) {
        a = parseFloat(match[4]); // Preserve existing alpha if present
      }
    }
  }
  // Handle Named Colors
  else {
    const tempCanvas = document.createElement("canvas");
    const tempCtx = tempCanvas.getContext("2d");
    if (tempCtx) {
      tempCtx.fillStyle = color;
      const computedColor = tempCtx.fillStyle; // Resolves named colors to RGB(A)
      return convertToRGBA(computedColor, opacity);
    }
  }

  return r !== undefined && g !== undefined && b !== undefined
    ? `rgba(${r}, ${g}, ${b}, ${opacity})`
    : color; // Fallback if conversion fails
};
